export type PricingTier = {
  id: string;
  name: string;
  tagline: string;
  price: number;
  annualPrice?: number;
  currency?: string;
  billingInterval: "month" | null;
  description: string;
  features: string[];
  excluded?: string[];
  limits: {
    maxEstimates: number | null;
    maxInvoices: number | null;
  };
  popular?: boolean;
  cta: string;
};

export const PRICING_TIERS: PricingTier[] = [
  {
    id: "free",
    name: "Free",
    tagline: "Start quoting today — No credit card required",
    price: 0,
    billingInterval: null,
    description: "Everything you need to create professional quotes and export them as PDFs.",
    features: [
      "Unlimited quotes & invoices",
      "PDF exports",
      "Customer management",
      "Cost catalog",
      "Basic insights",
    ],
    limits: {
      maxEstimates: null,
      maxInvoices: null,
    },
    cta: "Get Started Free",
  },
  {
    id: "pro",
    name: "Pro",
    tagline: "Run a faster, more professional business",
    price: 15,
    annualPrice: 12,
    currency: "USD",
    billingInterval: "month",
    description: "Speed up quoting, track real profit, automate email sending, and collect payment.",
    popular: true,
    features: [
      "Email sending",
      "Recurring & milestone invoices",
      "Progress payment milestones",
      "Projects — job command center with quoted vs actual",
      "Cost tracking & job costing",
      "Cost Report",
      "Reusable templates",
      "Your logo and brand color on quotes and invoices",
      "Custom PDF footer",
      "File attachments",
      "Import & export (CSV)",
      "Integrations — Stripe, QuickBooks, Zapier, Google Sheets",
      "Priority support",
    ],
    limits: {
      maxEstimates: null,
      maxInvoices: null,
    },
    cta: "Go Pro",
  },
];

export { PRO_FEATURES } from "./features";
export type { ProFeatureKey } from "./features";
